import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { brl } from "@/lib/api";

const TAG_LABEL = { promocao: "Promoção", novidade: "Novidade", destaque: "Destaque", lancamento: "Lançamento", mais_vendido: "Mais Vendido" };

export const ProductCard = ({ product, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`product-card-${product.slug}`}
  >
    <Link to={`/produto/${product.slug}`} className="group block">
      <div className="relative overflow-hidden bg-surface2 aspect-[3/4]">
        {product.tags?.[0] && (
          <span className="absolute top-3 left-3 z-10 bg-black/70 backdrop-blur text-rose label-caps text-[9px] px-2 py-1">
            {TAG_LABEL[product.tags[0]]}
          </span>
        )}
        <img src={product.image} alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
      </div>
      <div className="pt-4">
        <p className="label-caps text-white/40 text-[10px]">{product.category}</p>
        <h3 className="font-serif-display text-xl text-white mt-1 group-hover:text-rose transition-colors duration-300">{product.name}</h3>
        <p className="text-white/70 text-sm mt-1">{brl(product.price)}</p>
      </div>
    </Link>
  </motion.div>
);
